import { RequestStatus } from './network/managedRequest';
import { createSlice } from '@reduxjs/toolkit';
import {
    ACCOUNTING_AREA_ID_MARKER,
    processRequestForAccountingAreaWithReplacement,
} from './network/managedRequestForAccountingArea';
import { API } from '../constants';
import { PbDispatch, PbGetState } from './index';
import { PbRequest } from './pbRequest';

export interface MansionStatsDto {
    id: number;
    turnover: number;
    users: number;
    wash_cycles: number;
    currency: string;
}

export interface MansionIdToStats {
    [mansionId: number]: MansionStatsDto;
}

type ObjectStatsReply = MansionStatsDto[];

interface ObjectsStatsStore {
    mansionIdToStats: MansionIdToStats;
}

const initialState: ObjectsStatsStore = {
    mansionIdToStats: {},
};

const objectStatsSlice = createSlice({
    name: 'objectStats',
    initialState,
    reducers: {
        storeMansionIdToStats(state, action) {
            state.mansionIdToStats = action.payload;
        },
    },
});

export function MaybeLoadObjectStats(mansionId?: number) {
    return async (dispatch: PbDispatch, getState: PbGetState) => {
        const objectStats: ObjectsStatsStore = getState().objectStats;
        const currentObjectStatus =
            getState().pbRequest[PbRequest.GET_OBJECT_STATS].status;
        const isUnknownMansion =
            mansionId !== undefined && !objectStats.mansionIdToStats[mansionId];

        const isInitial = RequestStatus.INITIAL === currentObjectStatus;
        const isUnknownMansionAndNotLoading =
            RequestStatus.PENDING !== currentObjectStatus && isUnknownMansion;

        if (isInitial || isUnknownMansionAndNotLoading) {
            await LoadObjectStats()(dispatch);
        }
    };
}

export function LoadObjectStats() {
    return async (dispatch: PbDispatch) => {
        const request: RequestInit = { method: 'GET' };
        try {
            const response =
                await processRequestForAccountingAreaWithReplacement<ObjectStatsReply>(
                    dispatch,
                    `${API}/mansions/stats/${ACCOUNTING_AREA_ID_MARKER}`,
                    request,
                    PbRequest.GET_OBJECT_STATS
                );
            const mansionIdToStats = {};
            response.forEach(
                (objectStats) =>
                    (mansionIdToStats[objectStats.id] = objectStats)
            );
            dispatch(
                objectStatsSlice.actions.storeMansionIdToStats(mansionIdToStats)
            );
        } catch {
            // already handled
        }
    };
}

export default objectStatsSlice.reducer;
